import AuthenticationCard from '@/components/DataDisplay/Cards/AuthenticationCard/AuthenticationCard.tsx';
import PartnerRegistrationModal from '@/components/Forms/PartnerRegistration/PartnerRegistrationModal.tsx';
import usePartnerRegistration from '@/components/Forms/PartnerRegistration/usePartnerRegistration.ts';
import { useTranslations } from '@/contexts/translation/useTranslations';
import useAuthCard from '@/pages/authentication/AuthCard/useAuthCard.ts';
import EmailPasswordRecovery from '@/pages/authentication/EmailPasswordRecovery/EmailPasswordRecovery.tsx';
import Login from '@/pages/authentication/Login/Login.tsx';
import ThemeButton from '@/theme/Components/ThemeButton/ThemeButton.tsx';
import ThemeTypography from '@/theme/Components/ThemeTypography/ThemeTypography';
import { filePathAdapter } from '@/utils/utils.ts';
import { Flex, Image } from 'antd';

const AuthCard = () => {
  const {
    handleUserType,
    userType,
    forgotPasswordContent,
    currentDate,
    toggleContentForgotPassword,
    authenticationData,
  } = useAuthCard();
  const { t } = useTranslations({ ns: 'auth' });
  const {
    onSubmit: onPartnerRegister,
    loading: partnerRegisterLoading,
    captchaResetKey,
  } = usePartnerRegistration();
  const partnerForm =
    authenticationData?.pageData?.attributes?.rules?.partner?.form;
  const currentLang = authenticationData?.context?.langs?.find(
    (lang) => lang.current,
  )?.code;

  return (
    <AuthenticationCard
      backgroundColor={
        authenticationData?.pageData?.attributes?.sectionColor || ''
      }
    >
      {authenticationData?.pageData?.attributes?.logo && (
        <Flex align="center" justify="center" vertical>
          <Image
            preview={false}
            src={filePathAdapter(
              authenticationData?.pageData?.attributes?.logo || '',
            )}
            style={{ paddingBottom: 24, maxWidth: 170, maxHeight: 120 }}
          />
        </Flex>
      )}

      {userType ? (
        <>
          <Flex
            align="center"
            justify="center"
            style={{ paddingBottom: 48 }}
            vertical
          >
            {forgotPasswordContent ? (
              <EmailPasswordRecovery
                handleContent={toggleContentForgotPassword}
              />
            ) : (
              <Login handleForgotPassword={toggleContentForgotPassword} />
            )}
            {userType === 'partner' && partnerForm?.enabled && (
              <PartnerRegistrationModal
                captchaResetKey={captchaResetKey}
                cguUrl={
                  partnerForm.cguPageId
                    ? filePathAdapter(
                        `investorspace/page/${partnerForm.cguPageId}`,
                      )
                    : undefined
                }
                language={currentLang}
                loading={partnerRegisterLoading}
                onSubmit={onPartnerRegister}
                oriasOptional={partnerForm.oriasOptional}
                referralOptions={
                  partnerForm.referralOptions.length
                    ? partnerForm.referralOptions
                    : undefined
                }
                showPartnerCode={partnerForm.showPartnerCode}
                triggerLabel={t('login.partner.actions.create_account')}
                turnstileSiteKey={partnerForm.turnstileSiteKey}
              />
            )}
          </Flex>
          <ThemeTypography style={{ textAlign: 'center' }}>
            InvestHub.cloud © - {currentDate}
          </ThemeTypography>
        </>
      ) : (
        <Flex
          align="center"
          justify="center"
          style={{ paddingBottom: 48 }}
          vertical
        >
          <ThemeTypography style={{ textAlign: 'center' }} variant="h3">
            {t('login.common.welcome')}
          </ThemeTypography>
          <ThemeTypography style={{ textAlign: 'center', marginBottom: 48 }}>
            {t('login.common.subtitle')}
          </ThemeTypography>
          <Flex gap="middle" style={{ width: '100%' }} vertical>
            {authenticationData?.pageData?.attributes?.rules?.common
              ?.showInvestorBtn && (
              <ThemeButton
                block
                onClick={handleUserType('investor')}
                type="primary"
              >
                {t('login.common.actions.redirect_login_investor')}
              </ThemeButton>
            )}
            {authenticationData?.pageData?.attributes?.rules?.common
              ?.showPartnerBtn && (
              <ThemeButton
                block
                onClick={handleUserType('partner')}
                type="primary"
              >
                {t('login.common.actions.redirect_login_partner')}
              </ThemeButton>
            )}
          </Flex>
        </Flex>
      )}
    </AuthenticationCard>
  );
};

export default AuthCard;
